/**
 * Картинки редактора уезжают в files-service, в публичный бакет — тот же, из
 * которого CDN раздаёт статику. Приватная ручка сервиса берёт только клиентов
 * и сделки, для трекера её нет, и адрес картинки в документе получается
 * публичным: неугадываемым, но доступным всякому, кто его знает. Для описаний
 * задач и страниц знаний это осознанный размен на кэш и простую вставку.
 */
import { cdnUrl } from '@/api/cdn'
import { http } from '@/api/http'

interface UploadResponse {
  /** Имя файла в бакете, не адрес: URL собирает клиент */
  name?: string
}

/**
 * Загружает картинку и возвращает её адрес. Ошибку не глушим — редактор
 * покажет её на месте картинки.
 */
export const uploadEditorImage = async (file: File): Promise<string> => {
  const form = new FormData()

  form.append('file', file)

  const { data } = await http.post<UploadResponse>('/api/v1/files/upload', form, {
    // Не ради самого заголовка: у клиента по умолчанию стоит application/json,
    // а с ним axios сериализует форму в JSON и файл до сервиса не доедет.
    // Границу multipart дальше проставит браузер.
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  if (!data.name) throw new Error('files-service вернул ответ без имени файла')

  return cdnUrl(data.name)
}
